<template>
  <session-rating-question-layout :title="title">
    <template>
      <div class="control mb-2 has-fullwidth">
        <textarea class="textarea" v-model="message"></textarea>
      </div>
    </template>
  </session-rating-question-layout>
</template>

<script>
import SessionRatingQuestionLayout from "@/widgets/agenda/components/rating/SessionRatingQuestionLayout";

export default {
  name: "SessionRatingOpenQuestion",

  components: {SessionRatingQuestionLayout},

  props: {
    rating: {
      type: Object,
      required: true,
    },

    currentResponse: {
      type: String,
      default: "",
    }
  },

  data() {
    return {
      message: "",
    };
  },

  computed: {
    title() {
      return this.rating.title;
    },

    ratingId() {
      return this.rating.id;
    },

    type() {
      return this.rating.rating_type;
    }
  },

  watch: {
    currentResponse: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          this.message = newValue;
        }
      }
    },

    message: {
      immediate: true,
      handler: function (newValue) {
        if (newValue) {
          this.$emit("input", {ratingId: this.ratingId, type: this.type, responses: newValue});
        } else {
          this.$emit("input", {ratingId: this.ratingId, type: this.type, responses: null});
        }
      }
    }
  }
};
</script>

<style scoped></style>
